import { useEffect, useState } from "react";

const navItems = [
  { label: "首屏", href: "#top" },
  { label: "截图大图库", href: "#gallery" },
  { label: "主题合集", href: "#collections" },
  { label: "更新动态", href: "#updates" },
  { label: "常见问题", href: "#faq" },
];

interface SiteHeaderProps {
  onDownload: () => void;
}

export default function SiteHeader({ onDownload }: SiteHeaderProps) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-40 transition-colors duration-300 ${
        scrolled || menuOpen
          ? "bg-background-50/95 border-b border-background-200 backdrop-blur"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] w-full items-center justify-between px-4 md:px-6">
        <h1 className="flex items-center gap-2">
          <a href="#top" className="flex items-center gap-2 text-foreground-950">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-radar-line text-lg"></i>
            </span>
            <span className="text-lg md:text-xl font-bold tracking-tight">黑网爆料</span>
          </a>
        </h1>

        <nav className="hidden md:flex items-center gap-7">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-sm text-foreground-700 transition-colors hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onDownload}
            className="hidden sm:flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            <i className="ri-download-2-line text-base"></i>
            下载资料
          </button>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="md:hidden flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 cursor-pointer"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-2">
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="border-b border-background-100 py-3 text-sm text-foreground-800"
              >
                {item.label}
              </a>
            ))}
          </nav>
          <button
            type="button"
            onClick={() => {
              setMenuOpen(false);
              onDownload();
            }}
            className="mt-3 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50 cursor-pointer"
          >
            <i className="ri-download-2-line text-base"></i>
            下载资料
          </button>
        </div>
      )}
    </header>
  );
}